// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".testimonial-item[data-v-8c6c32a8]{display:flex;flex-direction:column;align-items:center;text-align:center;margin-bottom:1.5rem}.testimonial-item .user-image[data-v-8c6c32a8]{margin-bottom:1rem;border-radius:9999px;background-size:cover;background-position:50%;border-width:4px;--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity));width:110px;height:110px}", ""]);
// Exports
module.exports = exports;
